import { render, staticRenderFns } from "./OnlineConsultationsList.vue?vue&type=template&id=ef264c24&scoped=true"
import script from "./OnlineConsultationsList.vue?vue&type=script&lang=js"
export * from "./OnlineConsultationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef264c24",
  null
  
)

export default component.exports